'use client'

import { createContext, useContext } from 'react'

import type { DebugContextValue, DebugState } from './types'

const initialState: DebugState = {
	logs: [],
	networkRequests: [],
	userActions: [],
	hydrationErrors: [],
	isEnabled: false
}

const noop = () => {}
const noopWithId = () => ''

const defaultContextValue: DebugContextValue = {
	state: initialState,
	addLog: noop,
	addNetworkRequest: noopWithId,
	updateNetworkRequest: noop,
	addUserAction: noop,
	addHydrationError: noop,
	clearLogs: noop,
	clearNetworkRequests: noop,
	clearUserActions: noop,
	clearHydrationErrors: noop,
	clearAll: noop
}

export const DebugContext = createContext<DebugContextValue>(defaultContextValue)

export const useDebugContext = (): DebugContextValue => {
	return useContext(DebugContext)
}
